import { SlerpDrawer } from 'components/Widgets/SlerpDrawer/SlerpDrawer'

import styled from '@emotion/styled'
import { Drawer } from 'antd'

export const StyledSlerpDrawer = styled(SlerpDrawer)`
  .ant-drawer-header {
    background: transparent;

    .ant-drawer-header-title > button {
      order: 2;
    }

    .ant-drawer-header-title > .ant-drawer-title {
      order: 1;
    }
  }

  .ant-drawer-header-title button.ant-drawer-close {
    background-color: #4a4a68;
  }
`

export const StyledDrawer = styled(Drawer)<{
  colorScheme?: 'light' | 'dark'
}>`
  .ant-drawer-header {
    background: ${({ colorScheme }) =>
      colorScheme === 'light' ? '#fff' : '#4a4a68'};

    .ant-drawer-title {
      color: ${({ colorScheme }) =>
        colorScheme === 'light' ? '#4a4a68' : '#fff'};
    }

    .ant-drawer-header-title > button {
      order: 2;
    }

    .ant-drawer-header-title > .ant-drawer-title {
      order: 1;
    }
  }

  .ant-drawer-body {
    padding-top: 24px;
  }

  .reorder-strip {
    top: 88px;
  }

  .ant-drawer-header-title button.ant-drawer-close {
    background-color: ${({ colorScheme }) =>
      colorScheme === 'light' ? '#4a4a68' : '#d092dd'};
  }
`
